import axios from '@/utils/http';

// 支付宝停车助手相关接口

// 非支付宝端：查询该车牌/手机号是否可以开通停车助手
export function activatePaPermitCheck(data) {
    return axios({
        url: 'https://pacomponent.alipay-eco.com/pacomponent/uf/activatePaPermitCheck',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8',
        },
        data,
    });
}
